import { render, staticRenderFns } from "./FichaTecnicaForm.vue?vue&type=template&id=27dea1c8&scoped=true&lang=pug&"
import script from "./FichaTecnicaForm.vue?vue&type=script&lang=js&"
export * from "./FichaTecnicaForm.vue?vue&type=script&lang=js&"
import style0 from "./FichaTecnicaForm.vue?vue&type=style&index=0&id=27dea1c8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dea1c8",
  null
  
)

export default component.exports